module.exports = __webpack_public_path__ + "img/product6.ed1aff2c.png";